import { AppConfig } from '@ltvco/refresh-lib/ctx';
import { KeyboardEvent, useContext, useState } from 'react';

import { CHATBV_GA4_EVENTS } from 'components/ChatBV/constants';
import { ChatContext } from 'components/ChatBV/context';
import { ChatMessageData } from 'components/ChatBV/types';

// eslint-disable-next-line no-unused-vars
export const useChatForm = (
  onSendMessage?: (data: ChatMessageData) => void
) => {
  const { trackEventGA4 } = useContext(AppConfig);
  const [inputValue, setInputValue] = useState('');
  const [selectedImage, setSelectedImage] = useState<File | null>(null);
  const [imagePreviewUrl, setImagePreviewUrl] = useState<string | null>(null);

  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setInputValue(e.target.value);
  };

  const handleKeyPress = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey && inputValue.trim()) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  const handleImageSelect = (file: File) => {
    setSelectedImage(file);
    const reader = new FileReader();
    reader.onloadend = () => {
      setImagePreviewUrl(reader.result as string);
    };
    reader.readAsDataURL(file);
  };

  const handleRemoveImage = () => {
    setSelectedImage(null);
    setImagePreviewUrl(null);
  };

  const context = useContext(ChatContext);
  if (context === undefined) {
    throw new Error('useChat must be used within a ChatProvider');
  }
  const handleSendMessage = () => {
    if (inputValue.trim() || selectedImage) {
      trackEventGA4({
        event_name: CHATBV_GA4_EVENTS.name,
        type: CHATBV_GA4_EVENTS.message.type,
        subtype: CHATBV_GA4_EVENTS.message.subTypes.message_submit,
      });
      const messageData: ChatMessageData = {
        message: inputValue,
        ...(selectedImage && { imageFile: selectedImage }),
      };
      context.sendMessage(messageData.message, messageData.imageFile);
      if (onSendMessage) {
        onSendMessage(messageData);
      }
      setInputValue('');
      setSelectedImage(null);
      setImagePreviewUrl(null);
    }
  };

  return {
    inputValue,
    handleInputChange,
    handleKeyPress,
    handleSendMessage,
    selectedImage,
    imagePreviewUrl,
    handleImageSelect,
    handleRemoveImage,
  };
};
